module.exports = __webpack_public_path__ + "static/img/gongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gongan.png
// module id = bcVb
// module chunks = 2